module.exports = __webpack_public_path__ + "static/media/KS.3c68062f.svg";